// extracted by mini-css-extract-plugin
module.exports = {"head":"head_head___zLg0","hide":"head_hide__DtehS"};